import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.scss']
})
export class ConditionsComponent implements OnInit {
  customerHost = environment.usaHost;
  productName = environment.productName;

  currentLanguage: string;
  urlDoc10: SafeResourceUrl;

  monthlyFee = null;
  purchasePin = 0;
  atmWithdrawal = 2.5;
  cashReload= 4.99;
  balanceInquiry = 0.5;
  customerService = 0;
  inactivityCost = 1;
  directDeposit = 0;
  pinPurchase = 0.50;
  cardPurchase = 10;
  phoneNumber: string = '1-888-877-2268';

  isMobileDevice: boolean = false;

  constructor(
    public translate: TranslateService,
    private sanitizer: DomSanitizer) {
    translate.onLangChange.subscribe( (event: LangChangeEvent) => {
      this.currentLanguage = this.translate.currentLang === 'en' ? 'en' : 'es';
      const URL = `assets/documents/doc10_${this.currentLanguage}.pdf#toolbar=0&navpanes=0&scrollbar=0&zoom=page-width`;
      this.urlDoc10 = this.sanitizer.bypassSecurityTrustResourceUrl(URL);
    });
  }

  ngOnInit(): void {
    this.currentLanguage = this.translate.currentLang === 'en' ? 'en' : 'es';
    const URL = `assets/documents/doc10_${this.currentLanguage}.pdf#toolbar=0&navpanes=0&scrollbar=0&zoom=page-width`;
    this.urlDoc10 = this.sanitizer.bypassSecurityTrustResourceUrl(URL);
    this.isMobileDevice = this.isMobile();
  }

  isMobile(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegex.test(userAgent);
  }

}
